export const AVATAR_CLASS_NAME = 'kurama-Avatar'
export const AVATAR_GROUP_CLASS_NAME = 'kurama-AvatarGroup'
